import { render } from "./sidebarItem.vue?vue&type=template&id=33d4a7c3"
import script from "./sidebarItem.vue?vue&type=script&lang=js"
export * from "./sidebarItem.vue?vue&type=script&lang=js"

import exportComponent from "C:\\IdeaWork\\Dweb2024\\store-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__